export const englishCrmMessages = {
  resources: {
    companies: {
      name: "Company |||| Companies",
      forcedCaseName: "Company",
      fields: {
        name: "Company name",
        website: "Website",
        linkedin_url: "LinkedIn URL",
        phone_number: "Phone number",
        created_at: "Created at",
        nb_contacts: "Number of contacts",
        revenue: "Revenue",
        sector: "Sector",
        size: "Size",
        tax_identifier: "Tax Identifier",
        address: "Address",
        city: "City",
        zipcode: "Zip code",
        state_abbr: "State",
        country: "Country",
        description: "Description",
        context_links: "Context links",
        sales_id: "Account manager",
      },
      empty: {
        description: "It seems your company list is empty.",
        title: "No companies found",
      },
      field_categories: {
        contact: "Contact",
        additional_info: "Additional information",
        address: "Address",
        context: "Context",
      },
      action: {
        create: "Create Company",
        edit: "Edit company",
        new: "New Company",
        show: "Show company",
      },
      added_on: "Added on %{date}",
      followed_by: "Followed by %{name}",
      followed_by_you: "Followed by you",
      no_contacts: "No contact",
      nb_contacts: "%{smart_count} contact |||| %{smart_count} contacts",
      nb_deals: "%{smart_count} deal |||| %{smart_count} deals",
      sizes: {
        one_employee: "1 employee",
        two_to_nine_employees: "2-9 employees",
        ten_to_forty_nine_employees: "10-49 employees",
        fifty_to_two_hundred_forty_nine_employees: "50-249 employees",
        two_hundred_fifty_or_more_employees: "250 or more employees",
      },
      autocomplete: {
        create_error: "An error occurred while creating the company",
        create_item: "Create %{item}",
        create_label: "Start typing to create a new company",
      },
      filters: {
        only_mine: "Only companies I manage",
      },
    },
    contacts: {
      name: "Contact |||| Contacts",
      forcedCaseName: "Contact",
      field_categories: {
        background_info: "Background info",
        identity: "Identity",
        misc: "Misc",
        personal_info: "Personal info",
        position: "Position",
      },
      fields: {
        first_name: "First name",
        last_name: "Last name",
        last_seen: "Last seen",
        title: "Title",
        company_id: "Company",
        email_jsonb: "Email addresses",
        email: "Email",
        phone_jsonb: "Phone numbers",
        phone_number: "Phone number",
        linkedin_url: "LinkedIn URL",
        background: "Background info (bio, how you met, etc)",
        has_newsletter: "Has newsletter",
        sales_id: "Account manager",
      },
      action: {
        add: "Add contact",
        add_first: "Add your first contact",
        create: "Create contact",
        edit: "Edit contact",
        export_vcard: "Export to vCard",
        new: "New Contact",
        show: "Show contact",
      },
      background: {
        last_activity_on: "Last activity on %{date}",
        added_on: "Added on %{date}",
        followed_by: "Followed by %{name}",
        followed_by_you: "Followed by you",
        status_none: "None",
      },
      position_at: "%{title} at",
      position_at_company: "%{title} at %{company}",
      empty: {
        description: "It seems your contact list is empty.",
        title: "No contacts found",
      },
      import: {
        title: "Import contacts",
        button: "Import CSV",
        complete:
          "Contacts import complete. Imported %{importCount} contacts, with %{errorCount} errors",
        progress:
          "Imported %{importCount} / %{rowCount} contacts, with %{errorCount} errors.",
        error:
          "Failed to import this file, please make sure your provided a valid CSV file.",
        imported: "Imported",
        remaining_time: "Estimated remaining time:",
        running: "The import is running, please do not close this tab.",
        sample_download: "Download CSV sample",
        sample_hint: "Here is a sample CSV file you can use as a template",
        stop: "Stop import",
        csv_file: "CSV File",
        contacts_label: "contact |||| contacts",
      },
      inputs: {
        genders: {
          male: "He/Him",
          female: "She/Her",
          nonbinary: "They/Them",
        },
        personal_info_types: {
          work: "Work",
          home: "Home",
          other: "Other",
        },
      },
      list: {
        error_loading: "Error loading contacts",
      },
      inbox: {
        title: "Inbox",
        subtitle:
          "1:1 WhatsApp replies awaiting a response. Campaign broadcasts are excluded.",
        empty: "No unread WhatsApp messages. Nice work!",
      },
      bulk_tag: {
        action: "Tag",
        back: "Back to tags",
        create_description:
          "Create a new tag and apply it to the selected contacts.",
        description:
          "Choose an existing tag or create a new one for the selected contacts.",
        empty: "No tags yet. Create one to tag the selected contacts.",
        error: "Failed to add tag to contacts",
        noop: "Selected contacts already have this tag",
        success:
          "Tag added to %{smart_count} contact |||| Tag added to %{smart_count} contacts",
        title: "Add tag to contacts",
      },
      merge: {
        action: "Merge with another contact",
        confirm: "Merge Contacts",
        current_contact: "Current Contact (will be deleted)",
        description: "Merge this contact with another one.",
        error: "Failed to merge contacts",
        merging: "Merging...",
        no_additional_data: "No additional data to merge",
        select_target: "Please select a contact to merge with",
        success: "Contacts merged successfully",
        target_contact: "Target Contact (will be kept)",
        title: "Merge Contact",
        warning_description:
          "All data will be transferred to the second contact. This action cannot be undone.",
        warning_title: "Warning: Destructive Operation",
        what_will_be_merged: "What will be merged:",
      },
      filters: {
        before_last_month: "Before last month",
        before_this_month: "Before this month",
        before_this_week: "Before this week",
        managed_by_me: "Managed by me",
        ownership: "Ownership",
        inbox: "Inbox",
        unassigned: "Unassigned",
        desk_queues: "Desk queues",
        sla_overdue: "SLA — needs first touch",
        stale_48h: "Stale (48h+)",
        needs_whatsapp_reply: "Needs WhatsApp reply",
        needs_reply: "Needs reply",
        search: "Search name, company...",
        this_week: "This week",
        today: "Today",
        tags: "Tags",
        tasks: "Tasks",
      },
      sla: {
        ok: "New",
        warn: "SLA 15m",
        overdue: "SLA overdue",
        reassign: "Reassign owner",
        assign_to: "Assign to agent",
        assign_placeholder: "Select an agent…",
        assign_confirm: "Assign",
        reassign_ok: "Lead reassigned",
        reassign_error: "Could not reassign lead",
        agents_only: "Only managers can reassign ownership",
      },
      qualify: {
        qualifying: "Qualifying…",
      },
      assist: {
        lead_score: "Lead score",
        next_action: "Next action",
        suggest_reply: "Suggest reply",
        whatsapp_chat_presets: "Quick presets",
        engage: "Engage",
        call: "Call",
        whatsapp: "WhatsApp",
        schedule_visit: "Schedule visit",
        score_hot: "Hot",
        score_warm: "Warm",
        score_cold: "Cold",
      },
      hot: {
        empty_change_status:
          'Change the status of a contact by adding a note to that contact and clicking on "show options".',
        empty_hint: 'Contacts with a "hot" status will appear here.',
        title: "Hot Contacts",
      },
    },
    deals: {
      name: "Deal |||| Deals",
      fields: {
        name: "Name",
        description: "Description",
        company_id: "Company",
        contact_ids: "Contacts",
        category: "Category",
        amount: "Budget",
        expected_closing_date: "Expected closing date",
        stage: "Stage",
        sales_id: "Owner",
      },
      action: {
        back_to_deal: "Back to deal",
        create: "Create deal",
        new: "New Deal",
        board_view: "Board",
        table_view: "Table",
        view_mode: "Deal view",
      },
      field_categories: {
        misc: "Misc",
      },
      archived: {
        action: "Archive",
        error: "Error: deal not archived",
        list_title: "Archived Deals",
        success: "Deal archived",
        title: "Archived Deal",
        view: "View archived deals",
      },
      inputs: {
        linked_to: "Linked to",
      },
      unarchived: {
        action: "Send back to the board",
        error: "Error: deal not unarchived",
        success: "Deal unarchived",
      },
      updated: "Deal updated",
      empty: {
        before_create: "before creating a deal.",
        description: "It seems your deal list is empty.",
        title: "No deals found",
      },
      invalid_date: "Invalid date",
    },
    notes: {
      name: "Note |||| Notes",
      forcedCaseName: "Note",
      fields: {
        status: "Status",
        date: "Date",
        attachments: "Attachments",
        contact_id: "Contact",
        deal_id: "Deal",
      },
      action: {
        add: "Add note",
        add_first: "Add your first note",
        delete: "Delete note",
        edit: "Edit note",
        update: "Update note",
        add_this: "Add this note",
      },
      sheet: {
        create: "Create note",
        create_for: "Create note for %{name}",
        edit: "Edit note",
        edit_for: "Edit note for %{name}",
      },
      deleted: "Note deleted",
      empty: "No notes yet",
      author_added: "%{name} added a note",
      you_added: "You added a note",
      me: "Me",
      list: {
        error_loading: "Error loading notes",
      },
      note_for_contact: "Note for %{name}",
      stepper: {
        hint: "Go to a contact page and add a note",
      },
      added: "Note added",
      inputs: {
        add_note: "Add a note",
        options_hint: "(attach files, or change details)",
        show_options: "Show options",
      },
      actions: {
        attach_document: "Attach document",
      },
      validation: {
        note_or_attachment_required: "A note or an attachment is required",
      },
    },
    sales: {
      name: "Team member |||| Team Management",
      fields: {
        first_name: "First name",
        last_name: "Last name",
        email: "Email",
        administrator: "Admin",
        disabled: "Disabled",
      },
      create: {
        error: "An error occurred while creating the team member.",
        success:
          "Team member invited. They will receive an email to set their password.",
        title: "Invite team member",
      },
      edit: {
        error: "An error occurred. Please try again.",
        record_not_found: "Record not found",
        success: "Team member updated successfully",
        title: "Edit %{name}",
        reset_password: "Send password reset",
        reset_password_success: "Password reset email sent",
        reset_password_error: "Failed to send password reset email",
      },
      action: {
        new: "Invite member",
      },
    },
    tasks: {
      name: "Task |||| Tasks",
      forcedCaseName: "Task",
      fields: {
        text: "Description",
        due_date: "Due date",
        type: "Type",
        contact_id: "Contact",
        due_short: "due",
      },
      action: {
        add: "Add task",
        create: "Create task",
        edit: "Edit task",
      },
      actions: {
        postpone_next_week: "Postpone to next week",
        postpone_tomorrow: "Postpone to tomorrow",
        title: "task actions",
      },
      added: "Task added",
      deleted: "Task deleted successfully",
      dialog: {
        create: "Create task",
        create_for: "Create task for %{name}",
      },
      sheet: {
        edit: "Edit task",
        edit_for: "Edit task for %{name}",
      },
      empty: "No tasks yet",
      empty_list_hint: "Tasks added to your contacts will appear here.",
      filters: {
        later: "Later",
        overdue: "Overdue",
        this_week: "This week",
        today: "Today",
        tomorrow: "Tomorrow",
        with_pending: "With pending tasks",
      },
      regarding_contact: "(Re: %{name})",
      updated: "Task updated",
    },
    tags: {
      name: "Tag |||| Tags",
      action: {
        add: "Add tag",
        create: "Create new tag",
      },
      dialog: {
        color: "Color",
        create_title: "Create a new tag",
        edit_title: "Edit tag",
        name_label: "Tag name",
        name_placeholder: "Enter tag name",
      },
    },
    channel_partners: {
      commission_ledger: {
        title: "Commission ledger",
        summary:
          "%{count} booking(s) · %{agreement} agreement · %{commission} commission · %{pending} pending payout",
        empty: "No attributed bookings yet.",
        unit_unknown: "Unit N/A",
        agreement_value: "Agreement",
        payout_pending: "Pending",
        payout_paid: "Paid",
        mark_paid: "Mark paid",
        marking_paid: "Marking…",
        mark_paid_success: "Commission marked as paid.",
        mark_paid_failed: "Could not mark commission as paid.",
        agents_only: "Only managers can mark commissions as paid.",
      },
    },
  },
  crm: {
    action: {
      reset_password: "Reset Password",
    },
    auth: {
      first_name: "First name",
      last_name: "Last name",
      confirm_password: "Confirm password",
      confirmation_required:
        "Please follow the link we just sent you by email to confirm your account.",
      recovery_email_sent:
        "If you're a registered user, you should receive a password recovery email shortly.",
      sign_in_failed: "Failed to log in.",
      sign_in_google_workspace: "Sign in with Google Workplace",
      signup: {
        create_account: "Create account",
        create_first_user:
          "Create the first user account to complete the setup.",
        creating: "Creating...",
        initial_user_created: "Initial user successfully created",
      },
      welcome_title: "Welcome to Blivix CRM",
    },
    common: {
      activity: "Activity",
      added: "added",
      details: "Details",
      last_activity_with_date: "last activity %{date}",
      load_more: "Load more",
      misc: "Misc",
      past: "Past",
      read_more: "Read more",
      retry: "Retry",
      show_less: "Show less",
      copied: "Copied!",
      copy: "Copy",
      loading: "Loading...",
      me: "Me",
      task_count: "%{smart_count} task |||| %{smart_count} tasks",
    },
    changelog: {
      title: "Changelog",
    },
    activity: {
      added_company: "%{name} added company",
      you_added_company: "You added company",
      added_contact: "%{name} added",
      you_added_contact: "You added",
      added_note: "%{name} added a note about",
      you_added_note: "You added a note about",
      added_note_about_deal: "%{name} added a note about deal",
      you_added_note_about_deal: "You added a note about deal",
      added_deal: "%{name} added deal",
      you_added_deal: "You added deal",
      at_company: "at",
      to: "to",
      load_more: "Load more activity",
    },
    dashboard: {
      deals_chart: "Upcoming Deal Revenue",
      deals_pipeline: "Deals Pipeline",
      latest_activity: "Latest Activity",
      latest_activity_error: "Error loading latest activity",
      latest_notes: "My Latest Notes",
      latest_notes_added_ago: "added %{timeAgo}",
      needs_attention: {
        title: "Needs attention",
        todays_visits: "Today's visits",
        no_shows_this_week: "No-shows this week",
        all_clear: "All caught up — nice work!",
      },
      stepper: {
        install: "Install Blivix CRM",
        progress: "%{step}/3 done",
        whats_next: "What's next?",
      },
      upcoming_tasks: "Upcoming Tasks",
    },
    header: {
      import_data: "Import data",
    },
    image_editor: {
      change: "Change",
      drop_hint: "Drop a file to upload, or click to select it.",
      editable_content: "Editable content",
      title: "Upload and resize image",
      update_image: "Update Image",
    },
    import: {
      action: {
        download_error_report: "Download the error report",
        import: "Import",
        import_another: "Import another file",
      },
      error: {
        unable: "Unable to import this file.",
      },
      idle: {
        description_1:
          "You can import sales, companies, contacts, companies, notes, and tasks.",
        description_2:
          "Data must be in a JSON file matching the following sample:",
      },
      status: {
        all_success: "All records were imported successfully.",
        complete: "Import complete.",
        failed: "Failed",
        imported: "Imported",
        in_progress:
          "Import in progress, please don't navigate away from this page.",
        some_failed: "Some records were not imported.",
        table_caption: "Import status",
      },
      title: "Import Data",
    },
    settings: {
      about: "About",
      companies: {
        sectors: "Sectors",
      },
      dark_mode_logo: "Dark Mode Logo",
      deals: {
        categories: "Categories",
        currency: "Currency",
        pipeline_help:
          "Select which deal stages should count as pipeline deals.",
        pipeline_statuses: "Pipeline Statuses",
        stages: "Stages",
      },
      light_mode_logo: "Light Mode Logo",
      notes: {
        statuses: "Statuses",
      },
      reset_defaults: "Reset to Defaults",
      save_error: "Failed to save configuration",
      saved: "Configuration saved successfully",
      saving: "Saving...",
      tasks: {
        types: "Types",
      },
      preferences: "Preferences",
      title: "Settings",
      app_title: "App Title",
      sections: {
        branding: "Branding",
        agent_commission: "Agent commission",
        late_interest: "Late interest",
        hold_exclusivity: "Hold exclusivity",
        portal_spend: "Portal spend",
        whatsapp_templates: "WhatsApp templates",
        whatsapp_chat_presets: "WhatsApp chat presets",
      },
      late_interest: {
        help: "Annual simple interest applied to overdue milestone balances on demand letters (principal × rate × days / 365).",
        rate_label: "Annual late interest rate (%)",
      },
      hold_exclusivity: {
        help: "When on (recommended), only the agent who held the unit and managers/admins can release or change that hold. When off, any agent can change holds.",
        toggle_label: "Restrict hold changes to holding agent + managers",
      },
      agent_commission: {
        help: "Set how internal sales agents earn commission on agreement value.",
        mode_percent: "Flat percentage",
        mode_slab: "Slab tiers",
        rate_label: "Commission rate (%)",
        slab_min_agreement: "Min agreement value (₹)",
        slab_rate: "Rate (%)",
        add_slab: "Add slab",
        preview_title: "Live preview",
        preview_sample: "Sample agreement value: %{amount}",
        preview_result: "Agent earns %{rate}% → %{payout}",
      },
      portal_spend: {
        help: "Used for CPL on Analytics. Leave blank when unknown.",
      },
      whatsapp_chat_presets: {
        help: "Quick-reply buttons in the contact WhatsApp chat. Managers only. Use {name} for the contact name. Up to %{max} presets.",
        title_label: "Button label",
        body_label: "Message body",
        add: "Add preset",
        empty:
          "No chat presets yet. Add one for agents to use in WhatsApp chat.",
        title_placeholder: "e.g. Site Visit Invite",
        body_placeholder:
          "Namaste {name}! We would love to host you for a site visit…",
      },
      validation: {
        duplicate: "Duplicate %{display_name}: %{items}",
        in_use:
          "Cannot remove %{display_name} that are still used by deals: %{items}",
        validating: "Validating\u2026",
        entities: {
          categories: "categories",
          stages: "stages",
        },
      },
    },
    theme: {
      dark: "Dark",
      label: "Theme",
      light: "Light",
      system: "System",
    },
    language: "Language",
    navigation: {
      label: "CRM navigation",
    },
    profile: {
      inbound: {
        description:
          "You can start sending emails to your server's inbound email address, e.g. by adding it to the %{field} field. Blivix CRM will process the emails and add notes to the corresponding contacts.",
        title: "Inbound email",
      },
      mcp: {
        title: "MCP Server",
        description:
          "Use this URL to connect your AI assistant to your CRM data via the Model Context Protocol (MCP).",
      },
      password: {
        change: "Change password",
      },
      password_reset_sent:
        "A reset password email has been sent to your email address",
      record_not_found: "Record not found",
      title: "Profile",
      updated: "Your profile has been updated",
      update_error: "An error occurred. Please try again",
    },
    validation: {
      invalid_url: "Must be a valid URL",
      invalid_linkedin_url: "URL must be from linkedin.com",
    },
    analytics: {
      title: "Real Estate Analytics & Performance Suite",
      subtitle:
        "Track portal marketing ROI, Cost-Per-Lead (CPL), agent scorecard, and inventory aging.",
      no_leads_hint:
        "No leads yet — metrics stay at zero until contacts exist.",
      no_data: "No data",
      metrics: {
        total_leads: "Total Ingested Leads",
        total_leads_empty: "Empty until contacts are created or ingested",
        total_leads_source: "From contacts table",
        site_visits: "Site Visits Conducted",
        site_visits_count: "%{count} recorded visit(s)",
        tokens_bookings: "Tokens / Bookings",
        tokens_bookings_source: "From bookings table",
        gross_booking_value: "Gross Booking Value",
        gross_booking_value_source: "Sum of agreement values",
      },
      funnel: {
        title: "Lead funnel by source",
        description:
          "Lead → Contacted → Visit → Token → Booked progression per portal or source",
        empty: "No lead source data yet.",
        conversion: "Overall conversion: %{rate}",
        steps: {
          lead: "Lead",
          contacted: "Contacted",
          visit: "Visit",
          token: "Token",
          booked: "Booked",
        },
      },
      portal_volume: {
        title: "Portal Lead Volume vs Site Visit Conversions",
        description:
          "Comparative analysis of raw leads generated vs conducted site visits across portals",
      },
      portal_roi: {
        title: "Lead Source ROI & Portal Performance",
        description:
          "Breakdown of leads, contact rate, visits, tokens, bookings, and CPL by portal",
        columns: {
          source: "Portal / Source",
          leads: "Leads",
          contacted: "Contacted",
          visits: "Visits",
          tokens: "Tokens",
          booked: "Booked",
          cpl: "CPL",
          conversion: "Conversion",
        },
      },
      agent_scorecard: {
        title: "Agent scorecard",
        description:
          "First-touch speed, visit show-rate, bookings, and gross booking value",
        empty: "No agent scorecard data yet.",
        columns: {
          agent: "Agent",
          first_touch: "Avg first-touch (min)",
          show_rate: "Show-rate",
          completed_visits: "Completed visits",
          bookings: "Bookings",
          gross_value: "Gross booking value",
        },
      },
      call_leaderboard: {
        title: "Sales Team Leaderboard (calls)",
        description:
          "Agent ranking based on calls made, site visits, and gross sales booking value",
        columns: {
          agent: "Agent Name",
          calls: "Total Calls",
          site_visits: "Site Visits",
          tokens: "Tokens",
          gross_value: "Gross Booking Value",
        },
      },
      inventory_aging: {
        title: "Inventory aging",
        description:
          "Available and on-hold units ranked by days in current status",
        available_footnote:
          "Available days use unit created date (no status-change history yet).",
        empty: "No aging inventory to display.",
        showing: "Showing %{shown} of %{total} units",
        status: {
          available: "Available",
          on_hold: "On hold",
        },
        columns: {
          unit: "Unit",
          project: "Project",
          status: "Status",
          days: "Days",
        },
      },
      inventory_health: {
        title: "Project Inventory Health & Stacked Velocity",
        description:
          "Unit availability, tokens received, and booked/sold breakdown per developer project",
      },
    },
  },
} as const;

type MessageSchema<T> = {
  [K in keyof T]: T[K] extends string
    ? string
    : T[K] extends Record<string, unknown>
      ? MessageSchema<T[K]>
      : never;
};

type DeepPartial<T> = {
  [K in keyof T]?: T[K] extends Record<string, unknown>
    ? DeepPartial<T[K]>
    : T[K];
};

export type CrmMessages = MessageSchema<typeof englishCrmMessages>;
export type PartialCrmMessages = DeepPartial<CrmMessages>;
